import actions from './verify2FAActions';

const initState = {
    code: '',
    errorMessage: null,
    isErrorResend: false,
    secondsLeft: null,
    status: undefined,
    trusted: false,
};

const verify2FAReducer = (state = initState, action) => {
    switch (action.type) {
        case actions.VERIFY_2FA_FORM__CHANGE_CODE:
            return { ...state, code: action.code };

        case actions.VERIFY_2FA_FORM__TOGGLE_TRUSTED:
            return { ...state, trusted: action.trusted };

        case actions.VERIFY_2FA_FORM__ERROR:
            return {
                ...state,
                errorMessage: action.errorMessage,
                status: false,
            };

        case actions.VERIFY_2FA_FORM__SUBMIT:
            return { ...state, error: null, status: null };

        case actions.VERIFY_2FA_FORM__VERIFIED:
            return {
                ...state,
                error: null,
                nextUrl: action.nextUrl,
                status: true,
            };

        case actions.VERIFY_2FA_FORM__RESEND:
            return {
                ...state,
                isErrorResend: action.isErrorResend || state.isErrorResend,
                secondsLeft: action.secondsLeft,
            };
        case actions.VERIFY_2FA_FORM__CLEAR_SECONDS:
            return {
                ...state,
                secondsLeft: initState.secondsLeft,
                isErrorResend: initState.isErrorResend,
            };

        default:
            return state;
    }
};

export default verify2FAReducer;
